import React from 'react'
import ReactCountryFlag from 'react-country-flag'

import type { CountryCode } from './flags'

export interface FlagProps {
  code: CountryCode
  style?: React.CSSProperties
}

const Flag = ({ code, style = { width: 'auto', height: '1em' } }: FlagProps) => (
  <ReactCountryFlag data-e2e="origin-country" style={style} countryCode={code} svg alt={code} />
)

export default Flag
